import { h, render, hydrate } from 'preact';
import './styles/main.scss';
import { UnifiedDemoPage } from './pages/UnifiedDemoPage';
const searchMount = document.getElementById('search-app');
if (searchMount) {
    if (searchMount.hasChildNodes()) {
        hydrate(h(UnifiedDemoPage, null), searchMount);
    }
    else {
        render(h(UnifiedDemoPage, null), searchMount);
    }
}
